import React from 'react';
import { LayoutDashboard, Users, Mail, BarChart3, Settings, BookOpen, LogOut, Menu, X } from 'lucide-react';
interface SidebarProps {
  activePage: string;
  onNavigate: (page: string) => void;
  isMobileOpen: boolean;
  setIsMobileOpen: (open: boolean) => void;
}
export function Sidebar({
  activePage,
  onNavigate,
  isMobileOpen,
  setIsMobileOpen
}: SidebarProps) {
  const navItems = [{
    id: 'dashboard',
    label: 'Dashboard',
    icon: <LayoutDashboard size={20} data-id="element-60" />
  }, {
    id: 'students',
    label: 'Students',
    icon: <Users size={20} data-id="element-61" />
  }, {
    id: 'campaigns',
    label: 'Campaigns',
    icon: <BookOpen size={20} data-id="element-62" />
  }, {
    id: 'letters',
    label: 'Letters',
    icon: <Mail size={20} data-id="element-63" />
  }, {
    id: 'reports',
    label: 'Reports',
    icon: <BarChart3 size={20} data-id="element-64" />
  }, {
    id: 'settings',
    label: 'Settings',
    icon: <Settings size={20} data-id="element-65" />
  }];
  const sidebarClasses = `
    fixed inset-y-0 left-0 z-50 w-64 bg-white border-r border-stone-200 transform transition-transform duration-200 ease-in-out
    ${isMobileOpen ? 'translate-x-0' : '-translate-x-full'}
    md:relative md:translate-x-0
  `;
  return <>
      {/* Mobile Overlay */}
      {isMobileOpen && <div className="fixed inset-0 bg-stone-900/20 z-40 md:hidden" onClick={() => setIsMobileOpen(false)} data-id="element-66" />}

      {/* Sidebar */}
      <aside className={sidebarClasses} data-id="element-67">
        <div className="flex flex-col h-full" data-id="element-68">
          {/* Header */}
          <div className="h-16 flex items-center px-6 border-b border-stone-100" data-id="element-69">
            <div className="flex items-center gap-2 text-teal-700" data-id="element-70">
              <div className="w-8 h-8 bg-teal-600 rounded-lg flex items-center justify-center text-white font-bold text-xl" data-id="element-71">
                A
              </div>
              <span className="font-bold text-xl tracking-tight text-stone-900" data-id="element-72">
                Attend
              </span>
            </div>
            <button className="ml-auto md:hidden text-stone-500" onClick={() => setIsMobileOpen(false)} data-id="element-73">
              <X size={20} data-id="element-74" />
            </button>
          </div>

          {/* Standalone Mode Indicator */}
          <div className="px-4 py-4" data-id="element-75">
            <div className="bg-stone-50 border border-stone-200 rounded-lg p-3 flex items-start gap-3" data-id="element-76">
              <div className="p-1.5 bg-teal-100 text-teal-700 rounded-md" data-id="element-77">
                <BookOpen size={16} data-id="element-78" />
              </div>
              <div data-id="element-79">
                <div className="text-xs font-semibold text-stone-900 uppercase tracking-wide" data-id="element-80">
                  Campaign Mode
                </div>
                <div className="text-xs text-stone-500 mt-0.5" data-id="element-81">
                  Literacy features enabled
                </div>
              </div>
            </div>
          </div>

          {/* Navigation */}
          <nav className="flex-1 px-3 py-2 space-y-1 overflow-y-auto" data-id="element-82">
            {navItems.map(item => <button key={item.id} onClick={() => {
            onNavigate(item.id);
            setIsMobileOpen(false);
          }} className={`
                  w-full flex items-center gap-3 px-3 py-2.5 rounded-lg text-sm font-medium transition-colors
                  ${activePage === item.id ? 'bg-teal-50 text-teal-700' : 'text-stone-600 hover:bg-stone-50 hover:text-stone-900'}
                `} data-id="element-83">
                {item.icon}
                {item.label}
              </button>)}
          </nav>

          {/* Footer */}
          <div className="p-4 border-t border-stone-100" data-id="element-84">
            <div className="flex items-center gap-3 px-3 py-2 text-sm font-medium text-stone-600 hover:text-stone-900 cursor-pointer rounded-lg hover:bg-stone-50" data-id="element-85">
              <div className="w-8 h-8 rounded-full bg-coral-100 flex items-center justify-center text-coral-700 font-bold" data-id="element-86">
                JD
              </div>
              <div className="flex-1 min-w-0" data-id="element-87">
                <div className="truncate" data-id="element-88">Jane Doe</div>
                <div className="text-xs text-stone-400 truncate" data-id="element-89">
                  Admin • District 4
                </div>
              </div>
              <LogOut size={16} className="text-stone-400" data-id="element-90" />
            </div>
          </div>
        </div>
      </aside>
    </>;
}